var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "1200" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "p-0" },
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [
                    _vm._v(_vm._s(!!_vm.form.grupo ? "edit" : "add"))
                  ]),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        !!_vm.form.grupo ? "Editar horario" : "Crear horario"
                      ) +
                      "\n      "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "px-3" },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "p-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Descripción",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.descripcion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "descripcion", $$v)
                                  },
                                  expression: "form.descripcion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  items: _vm.tipo_jornada,
                                  "item-value": "id",
                                  "item-text": "tipo",
                                  label: "Ingrese la jornada laboral",
                                  rules: _vm.$validate(["required"]),
                                  outline: "",
                                  clearable: "",
                                  required: "",
                                  disabled: !!_vm.form.grupo,
                                  readonly: !!_vm.form.grupo
                                },
                                model: {
                                  value: _vm.form.jornada,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "jornada", $$v)
                                  },
                                  expression: "form.jornada"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.form.jornada == "C"
                          ? _vm.l_horarios.filter(function(ele) {
                              return ele.numero == 1
                            })
                          : _vm.l_horarios,
                        function(horario) {
                          return _c(
                            "v-layout",
                            { key: horario.id, attrs: { wrap: "", row: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: "#ff5c0a",
                                        "text-color": "white"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.form.jornada == "C"
                                              ? horario.desc1_continuo
                                              : horario.desc1_discontinuo
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Hora Ingreso ",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: "",
                                      type: "time"
                                    },
                                    model: {
                                      value: horario.hora_inicio,
                                      callback: function($$v) {
                                        _vm.$set(horario, "hora_inicio", $$v)
                                      },
                                      expression: "horario.hora_inicio"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Tolerancia en min.",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: "",
                                      type: "time"
                                    },
                                    model: {
                                      value: horario.tolerancia_inicio,
                                      callback: function($$v) {
                                        _vm.$set(
                                          horario,
                                          "tolerancia_inicio",
                                          $$v
                                        )
                                      },
                                      expression: "horario.tolerancia_inicio"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Rango inicio (Para procesar)",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: "",
                                      type: "time"
                                    },
                                    model: {
                                      value: horario.rango_inicio_inicio,
                                      callback: function($$v) {
                                        _vm.$set(
                                          horario,
                                          "rango_inicio_inicio",
                                          $$v
                                        )
                                      },
                                      expression: "horario.rango_inicio_inicio"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Rango fin (Para procesar)",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: "",
                                      type: "time"
                                    },
                                    model: {
                                      value: horario.rango_fin_inicio,
                                      callback: function($$v) {
                                        _vm.$set(
                                          horario,
                                          "rango_fin_inicio",
                                          $$v
                                        )
                                      },
                                      expression: "horario.rango_fin_inicio"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: "indigo",
                                        "text-color": "white"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.form.jornada == "C"
                                              ? horario.desc2_continuo
                                              : horario.desc2_discontinuo
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Hora Salida ",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: "",
                                      type: "time"
                                    },
                                    model: {
                                      value: horario.hora_fin,
                                      callback: function($$v) {
                                        _vm.$set(horario, "hora_fin", $$v)
                                      },
                                      expression: "horario.hora_fin"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Tolerancia en min.",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: "",
                                      type: "time"
                                    },
                                    model: {
                                      value: horario.tolerancia_fin,
                                      callback: function($$v) {
                                        _vm.$set(horario, "tolerancia_fin", $$v)
                                      },
                                      expression: "horario.tolerancia_fin"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label:
                                        "Rango inicio en min. (Para procesar)",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: "",
                                      type: "time"
                                    },
                                    model: {
                                      value: horario.rango_inicio_fin,
                                      callback: function($$v) {
                                        _vm.$set(
                                          horario,
                                          "rango_inicio_fin",
                                          $$v
                                        )
                                      },
                                      expression: "horario.rango_inicio_fin"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Rango fin en min.(Para procesar)",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: "",
                                      type: "time"
                                    },
                                    model: {
                                      value: horario.rango_fin_fin,
                                      callback: function($$v) {
                                        _vm.$set(horario, "rango_fin_fin", $$v)
                                      },
                                      expression: "horario.rango_fin_fin"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "v-chip",
                        { attrs: { color: "cyan", "text-color": "white" } },
                        [_vm._v("Jornadas")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        _vm._l(_vm.l_jornadas, function(jornada, index) {
                          return _c(
                            "v-flex",
                            {
                              key: index,
                              attrs: { xs12: "", sm6: "", md4: "" }
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-2 text-xs-center",
                                  staticStyle: { "border-radius": "15px" },
                                  attrs: { color: jornada.color }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticStyle: { "font-weight": "800" },
                                          attrs: { xs12: "" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(jornada.descripcion) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "d-flex justify-center",
                                          attrs: { xs12: "" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "material-symbols-outlined",
                                              staticStyle: {
                                                "font-size": "10rem",
                                                position: "absolute",
                                                color: "rgba(0, 0, 0,0.035)"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(jornada.icono) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "text-field-reducido-border",
                                            attrs: {
                                              label: "Hora inicio",
                                              rules: _vm.$validate([
                                                "required"
                                              ]),
                                              required: "",
                                              outline: "",
                                              clearable: "",
                                              type: "time"
                                            },
                                            model: {
                                              value: jornada.hora_inicio,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  jornada,
                                                  "hora_inicio",
                                                  $$v
                                                )
                                              },
                                              expression: "jornada.hora_inicio"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "text-field-reducido-border",
                                            attrs: {
                                              label: "Hora fin",
                                              rules: _vm.$validate([
                                                "required"
                                              ]),
                                              required: "",
                                              outline: "",
                                              clearable: "",
                                              type: "time"
                                            },
                                            model: {
                                              value: jornada.hora_fin,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  jornada,
                                                  "hora_fin",
                                                  $$v
                                                )
                                              },
                                              expression: "jornada.hora_fin"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: !_vm.valid
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2774ff6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2774ff6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/horario/dialogs/CrearActualizarHorario.vue
// module id = null
// module chunks = 